module.exports = __webpack_public_path__ + "img/27.d1cf2c1e.png";